import React, { useState, useEffect } from 'react';
import { AccessRequestFormStatus, ACCESS_REQUEST_STATUS } from '@awp/constants';
import TopHeader from '@awp/TopHeader';
import Footer from '@awp/Footer';
import { Container } from 'react-bootstrap';
import { REST_API } from '@awp/constants';
import { PostJson, PutJson } from '@awp/helpers/fetchReact';
import { Crud } from '@awp/shared/Crud';
import HeaderMenu from '@components/Navigation/HeaderMenu';
const AccessRequest = ({ currentUser, isBarExpanded, setIsBarExpanded }) => {
  const [submissionComment, setSubmissionComment] = useState(currentUser.SubmissionComment);
  const [mode, setMode] = useState('');
  const [saveResult, setSaveResult] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const expandedClick = () => {
    setIsBarExpanded(isBarExpanded ? false : 'expanded');
  };

  const crud = new Crud('Request Access', mode);

  const handleCommentChange = (event) => {
    setSubmissionComment(event.target.value);
  };

  const handleSubmit = async () => {
    const url = REST_API.ACCESS_REQUEST;
    const accessRequest = {
      UserType: currentUser.UserType,
      SecurityIdentifierId: currentUser.SecurityIdentifierId,
      SubmissionComment: submissionComment.trim(),
    };

    let response;

    try {
      setSubmitting(true);
      response =
        mode === AccessRequestFormStatus.Create
          ? await PostJson(url, accessRequest)
          : await PutJson(`${url}${currentUser.AccessRequestId}`, accessRequest);
      if (response.ok) setSaveResult('success');
      else setSaveResult('fail');
    } catch (ex) {
      setSaveResult('fail');
      console.error(ex);
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    const status = currentUser.AccessRequestStatus;
    if (status === ACCESS_REQUEST_STATUS.NONE) setMode(AccessRequestFormStatus.Create);
    else if (status === ACCESS_REQUEST_STATUS.EDITABLE_PENDING) setMode(AccessRequestFormStatus.Update);
    else setMode(AccessRequestFormStatus.Pending);
  }, []);

  const SaveFail = () => {
    if (saveResult !== 'fail') return <></>;
    return (
      <div id="message_fail" className="card-footer">
        <h3 id="header_title_error" className="text-danger">
          <i className="bi-exclamation-triangle-fill"></i> Error with Request!
        </h3>
        <p className="text-danger">
          We are sorry, there was an issue with your submission and we could not process your request at this time.
        </p>
      </div>
    );
  };

  const SaveSuccess = () => {
    if (saveResult !== 'success') return <></>;
    return (
      <>
        <div id="message_success" className="card-footer text-success">
          <h3 id="header_title_success">
            <i className="bi-check-circle-fill"></i> Request sent successfully!
          </h3>

          <div>
            <p>Your request has been successfully submitted and is awaiting approval.</p>
            <span style={{ fontSize: 'medium' }}>
              <b>What happens next</b>
            </span>
            <p>
              Your request will be processed by the AWP team. You should receive a response within 24 hours via email.
              <br />
              If you have any questions, please contact IT services via email at{' '}
              <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
            </p>
            <p>
              <a
                href="https://www2.gov.bc.ca/gov/content/transportation/transportation-environment/avalanche-safety-program"
                target="_blank"
                rel="noreferrer"
              >
                Learn more about the Avalanche and Weather Programs
              </a>
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <TopHeader user={currentUser} expandedClick={expandedClick} isBarExpanded={isBarExpanded} />
      <HeaderMenu expandedClick={expandedClick} isBarExpanded={isBarExpanded} />
      <Container>
        <div className="card mt-3">
          <div id="header_title" className="card-header">
            {crud.getHeader()}
          </div>

          <div id="access_request_form">
            {mode === AccessRequestFormStatus.Create && (
              <div className="card-body">
                <br />
                <h4>Hello {currentUser.FullName}, you are not authorized to access this system.</h4>

                <p>
                  In the text field below, please explain why you require access to the Snow Avalanche and Weather
                  System.
                  <br />
                  If you have any questions, please contact this email:{' '}
                  <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
                </p>
                {saveResult === '' && (
                  <div className="form-group" id="form_message">
                    <span style={{ fontSize: 'small' }}>
                      <b>Please explain why you need access to the system</b>
                    </span>
                    <textarea
                      id="comments"
                      name="SubmissionComment"
                      className="form-control required w-75"
                      rows={6}
                      maxLength="250"
                      value={submissionComment}
                      onChange={handleCommentChange}
                    ></textarea>
                    <br />
                    <div className="js-form-actions">
                      <button
                        className="btn btn-primary"
                        id="submit_access_request_btn"
                        onClick={handleSubmit}
                        disabled={!submissionComment?.trim() || submitting}
                      >
                        Submit Request
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
            {mode === AccessRequestFormStatus.Update && (
              <div className="card-body">
                <br />
                <h4>Your request is currently being processed by the AWP team.</h4>

                <p>
                  If you would like to resubmit or update your request then please review your entry.
                  <br />
                  For any questions, please contact IT services by email at{' '}
                  <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
                </p>
                {saveResult === '' && (
                  <div className="form-group" id="form_message">
                    <span style={{ fontSize: 'small' }}>
                      <b>Request information submitted on {currentUser.SubmissionTime}</b>
                    </span>

                    <textarea
                      id="comments"
                      name="SubmissionComment"
                      className="form-control required w-75"
                      rows={6}
                      maxLength="250"
                      value={submissionComment}
                      onChange={handleCommentChange}
                    ></textarea>
                    <br />
                    <div className="js-form-actions">
                      <button
                        className="btn btn-primary"
                        id="submit_access_request_btn"
                        onClick={handleSubmit}
                        disabled={
                          !submissionComment?.trim() ||
                          submissionComment === currentUser.SubmissionComment ||
                          submitting
                        }
                      >
                        Update Request
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
            {mode === AccessRequestFormStatus.Pending && (
              <div className="card-body">
                <br />
                <h4>A request has been previously submitted.</h4>

                <p>
                  Your request is currently being processed by the AWP team. You should receive a response within 24
                  hours by email.
                  <br />
                  If you have any questions, please contact IT services via email at{' '}
                  <a href="mailto:awpit@gov.bc.ca">awpit@gov.bc.ca</a>
                </p>
                <p>
                  <a
                    href="https://www2.gov.bc.ca/gov/content/transportation/transportation-environment/avalanche-safety-program"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Learn more about the Avalanche and Weather Programs
                  </a>
                </p>
              </div>
            )}
            <SaveSuccess />
            <SaveFail />
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default AccessRequest;
